// import 'bootstrap/dist/js/bootstrap'
import 'bootstrap'

// include through webpack.ProvidePlugin with exports-loader
import 'bootstrap/js/dist/util'

import Popper from 'popper.js'
/* import Tooltip from 'bootstrap/js/dist/tooltip' */
import Popover from 'bootstrap/js/dist/popover'

import 'bootstrap/scss/bootstrap.scss'

/* import validation plugin */
import validator from 'jquery-validation/dist/jquery.validate.min.js'

/* importing Fancybox */
//import fancybox from '@fancyapps/fancybox'
//import '@fancyapps/fancybox/dist/jquery.fancybox.min.css'


/* Importing style */
require('../style/general.scss');

$('a.nav-link[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });


  var sections = $('section')
  , nav = $('nav')
  , nav_height = nav.outerHeight();
  
$(window).on('scroll', function () {
    var cur_pos = $(this).scrollTop();
   
    sections.each(function() {
      var top = $(this).offset().top - nav_height,
          bottom = top + $(this).outerHeight();
   
      if (cur_pos >= top && cur_pos <= bottom) {
        nav.find('a').removeClass('active');
        sections.removeClass('active');
   
        $(this).addClass('active');
        nav.find('a[href="#'+$(this).attr('id')+'"]').addClass('active');
      }
    });
  });

jQuery(function() {

    $(window).scroll(function(){ 
        if ($(this).scrollTop() > 100) { 
            $('#scroll-to-top').fadeIn(); 
        } else { 
            $('#scroll-to-top').fadeOut(); 
        } 
    }); 
    $('#scroll-to-top').click(function(){ 
        $("html, body").animate({ scrollTop: 0 }, 600); 
        return false; 
    }); 

}); //End of $(document).ready(...)


// WEBPACK FOOTER //
// ./src/js/main.js